import React, { useEffect } from 'react';
import './psfomart.css';
import { psfomart } from '../../json/psfomart';

const Psfomart = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa de Fomento Artesanal</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold' }}>Descripción del Programa</h5>
                <p>
              
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                Contribuirá a generar mayores y mejores condiciones para acrecentar su producción a través de apoyos económicos para la adquisición de materia prima y/o herramientas, la motivación de continuar con este tipo de actividades en los artesanos es fundamental, como parte importante de nuestro patrimonio cultural e histórico, y se atenderá por medio de cursos y talleres; a través de ferias y/o espacios para ventas, se estima la proyección de su mercado, que permita a los artesanos un mejor aporte a su economía, teniendo así una real alternativa de empleo o incluso, como una principal fuente de empleo donde trabajen ya sea de forma individual, en grupo.
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a mejorar el ingreso de las personas artesanas hidalguenses o que radiquen en el Estado con un mínimo de 5 años, mediante el impulso y desarrollo de actividades artesanales como son: apoyos para promoción, producción, capacitación y comercialización.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Población Objetivo</h5>
                <p>
                Artesanas y artesanos hidalguenses con radicación mínima de 5 años en el Estado, así como a los ya inscritos en el padrón único de artesanas, artesanos y empresas de la actividad artesanal de la DGFA.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Cobertura</h5>
                <p>
                Artesanas y artesanos hidalguenses con radicación mínima de 5 años en el Estado, así como a los ya inscritos en el padrón único de artesanas, artesanos y empresas de la actividad artesanal de la DGFA.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Participación Social y Fomento Artesanal<br />
                  </li>
                  <li>Dirección General de Fomento Artesanal<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Personas Responsables del Programa</h5>
                <p>
                  
                  <ul>
                  <li>Mtro. César Aurelio Monroy Vega<br />                    
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Teléfono de Contacto</h5>
                <p>
                (771) 713-04 12<br />
                (771) 713-09 66                             

                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2023/ROPS_Fomento_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reglas de Operación</a></strong></h5>
                <p>
                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Benef_4oT_2023_Fom_Art.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Padrón de Beneficiarios</a></strong></h5>
                <p>
                </p>
                <p>
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psfomart;